import CareersApplicationForm from "@/components/forms/careers-application-form";
import { Component } from "@builder.io/sdk";

// Define the builder config for CareersApplicationForm component
export const careersApplicationFormConfig: Component = {
  name: "Careers Application Form",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "careers-application-form",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Ready to Apply?",
      helperText: "Heading text for the section",
    },
    {
      name: "subheading",
      type: "string",
      defaultValue: "Fill out the form to start the process.",
      helperText: "Subheading text for the section",
    },
    {
      name: "testimonialCopy",
      type: "string",
      defaultValue:
        "We've had more than 10,000 caregivers and nurses in 14 years",
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "testimonials",
      type: "list",
      helperText: "Testimonials to display",
      defaultValue: [
        {
          image:
            "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Ffb4a93d4bc95448ba741b0524c427cb6",
          name: "Marie J.",
          date: "OCT 2024",
          stars: 5,
          text: "I have been working for Care Indeed for many years. It's a great company that provides premium care to their clients. They provide a flexible schedule for their employees.",
        },
        {
          image:
            "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Ffc4626b281bf436da617721e3a60aaf4",
          name: "Rashmi M.",
          date: "SEP 2024",
          stars: 5,
          text: "I've chosen to be happy. I'm happy to serve the elderly citizens who need my help. The Care Indeed gave me the golden opportunity to make senior citizens happy. Care Indeed is a great place to work ❤️.",
        },
      ],
      subFields: [
        {
          name: "image",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          helperText: "Image of the person giving the testimonial",
        },
        {
          name: "name",
          type: "string",
          helperText: "Name of the person giving the testimonial",
        },
        {
          name: "date",
          type: "string",
          helperText: "Date of the testimonial (e.g., OCT 2024)",
        },
        {
          name: "stars",
          type: "number",
          defaultValue: 5,
          helperText: "Rating from 1-5 stars",
        },
        {
          name: "text",
          type: "richText",
          helperText: "Testimonial text content",
        },
      ],
    },
  ],
};

export default CareersApplicationForm;
